import { useState } from 'react';
const useMenu = () => {
    const [zipSelectorVisible, setZipSelectionVisibility] = useState(false);
    const [storeSelectorVisible, setStoreSelectorVisibility] = useState(false);
    const openZipSelector = () => {
        setZipSelectionVisibility(true);
    };
    const closeZipSelector = () => {
        setZipSelectionVisibility(false);
    };
    const openStoreSelector = () => {
        setStoreSelectorVisibility(true);
    };
    const closeStoreSelector = () => {
        setStoreSelectorVisibility(false);
    };
    return {
        zipSelectorVisible,
        storeSelectorVisible,
        openZipSelector,
        closeZipSelector,
        openStoreSelector,
        closeStoreSelector
    };
};
export default useMenu;
//# sourceMappingURL=useMenu.js.map